<template>
  <content-dialog
    :visible.sync="modalVisible"
    :persistent="$store.state.ui.alert.active"
    max-width="400px"
  >
    <!--<editor-fold desc="Dialog Title">-->
    <template slot="dialogTitle">
      Deny request
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Content">-->
    <v-card-text :class="{'pa-4': $vuetify.breakpoint.smAndUp }">
      <v-textarea
        v-model="reason"
        v-validate="'required|min:5'"
        outlined
        single-line
        placeholder="Enter reason for denying..."
        name="request_declined_reason"
        data-vv-as="deny reason"
        :error-messages="veeErrors.collect('request_declined_reason')"
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Deny request
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
  import ContentDialog from '@/components/helpers/Dialog'

  export default {
    name: 'ServiceTaskRequestDenyDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        reason: null
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (val) {
          this.$emit('update:visible', val)
        }
      }
    },
    methods: {
      async submit() {
        let validation = await this.$validator.validate()

        if (!validation) return

        this.$emit('submit', this.reason)
        this.modalVisible = false
        this.reason = null
      }
    }
  }
</script>
